 const searchSX = {
    backgroundColor: "rgba(0,0,0,0)",
    border: "3px solid #008000",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "rgb(52, 143, 27, 0.1)",
    },
    "&:focus": {
      backgroundColor: "rgb(52, 143, 27, 0.3) !important",
      // border: "1px solid #82D782 !important",
    },
    "&.Mui-selected": {
      backgroundColor: "rgb(52, 143, 27, 0.9) !important",
      // border: "1px solid #82D782 !important",
    }, 
  };

  export default searchSX